var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 12.5002V15.0002H4.99992V12.5002H3.33325V15.0002C3.33325 15.9168 4.08325 16.6668 4.99992 16.6668H14.9999C15.9166 16.6668 16.6666 15.9168 16.6666 15.0002V12.5002H14.9999ZM14.1666 9.16683L12.9916 7.99183L10.8333 10.1418V3.3335H9.16658V10.1418L7.00825 7.99183L5.83325 9.16683L9.99992 13.3335L14.1666 9.16683Z",
    fill: "url(#paint0_linear_137_14837)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_14837",
    x1: 3.33325,
    y1: 3.3335,
    x2: 6.63338,
    y2: 18.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDisabledIcon);
export default __webpack_public_path__ + "static/media/downloadDisabledIcon.bb4b051f4e857c14b549b5dfc38fe948.svg";
export { ForwardRef as ReactComponent };